import Api from "../../axios";

export const addCompOffForEmployee = async (data) => {
  return await Api.post("/add_compoff", data);
};